import gql from "graphql-tag";

export const GET_INBOX_TASKS = gql`
	query GetUserInboxTasks($where: UserWhere!, $taskWhere: UserTasksConnectionWhere!, $first: Int) {
		tasks: users(where: $where) {
			tasksConnection(where: $taskWhere, first: $first, sort: { node: { timeStamp: DESC } }) {
				edges {
					node {
						id
						taskStatus
						triggerEventId
						timeStamp
						createdBy {
							id
							organization {
								name
							}
						}
						agreement {
							id
							name
							userRolesConnection {
								edges {
									node {
										id
									}
									isAssignee
								}
							}
						}
						caseConnection {
							edges {
								formDueOrOverdue
								node {
									id
									agreement {
										id
									}
									caseAssignee {
										id
									}
								}
							}
						}
						document {
							id
							creatorOrgName
							type
							assignedTo {
								id
							}
						}
					}
					isCompleted
				}
			}
		}
		flexEntityTypes {
			id
			containerType
			localizationKey
		}
	}
`;

export const GET_INBOX_NOTIFICATION_FILTERS = gql`
	query GetUserContextFiltersInboxNotification {
		filters: GetUserContextFiltersInboxNotification
	}
`;

export const UPDATE_INBOX_NOTIFICATION_FILTERS = gql`
	mutation UpdateUserContextFiltersInboxNotification($req: String) {
		UpdateUserContextFiltersInboxNotification(req: $req)
	}
`;

export const READ_OR_UNREAD_TASK = gql`
	mutation ReadOrUnreadTask($taskId: ID!, $taskStatus: TaskStatus!) {
		ReadOrUnreadTask(taskId: $taskId, taskStatus: $taskStatus)
	}
`;

export const TASKS_SUBSCRIPTION = gql`
	subscription OnTaskUpdated {
		taskUpdated
	}
`;
